<!-- Change Bill Owner Modal  -->
<p-dialog [(visible)]="changeBillOwnerModal" [resizable]="false" appendTo="body" [modal]="true" [closeOnEscape]="true"
  (onHide)="closeDialogEvent()" [breakpoints]="{'767px': '100vw'}" [style]="{width: '660px'}"
  styleClass="no-header-modal overflow-visible">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <ng-container
      *ngIf="{client: invoiceData, staff: currentStaff$ | async, allStaff: allStaffs$ | async, selectedStaff: selectedStaff$ | async} as $">

      <!-- Header -->
      <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">

        <div class="flex align-items-center">
          <h2 class="mb-0 text-sm">{{'BILL_OWNER_CHANGE.CHANGE_BILL_OWNER' | translate}}
            <strong>{{$.client.billing_name}}</strong>
            <span class="text-xs text-600"> - {{$.client.client_id}}</span></h2>
        </div>
        <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeDialogEvent()"></div>
      </div>
      <!-- Header -->

      <form [formGroup]="updateBillOwnerForm">

        <!-- Modal Content -->
        <div class="surface-100 border-bottom-1 border-300 p-3 md:px-5">

          <!-- Column -->
          <div class="mb-4">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase">{{'BILL_OWNER_CHANGE.CURRENT_BILL_OWNER' | translate}}</label>

            <div class="flex align-items-center">
              <span *ngIf="$.staff.ff_picture; else noContactPic">
                <p-avatar image="{{$.staff.ff_picture}}" class="w-2rem h-2rem border-circle mr-2" shape="circle">
                </p-avatar>
              </span>
              <ng-template #noContactPic>
                <p-avatar styleClass="mr-2" *ngIf="$.staff.name" label="{{$.staff.name | titlecase | shortName}}"
                  shape="circle"></p-avatar>
              </ng-template>
              <span class="text-sm">{{$.staff.name}}</span>
            </div>
          </div>
          <!-- Column -->

          <!-- Column -->
          <div class="">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase">{{'BILL_OWNER_CHANGE.NEW_BILL_OWNER' | translate}}</label>
            <!-- <div class="relative"> -->
            <staff-selector [formGroup]="updateBillOwnerForm" [controlName]="NewRepresentative"
              [canRepresetative]="isClientRepresentative" [claims]="claims"
              [styleClass]="'w-full text-sm py-0 align-items-center'" [filterstaff]="staffIds$">
            </staff-selector>
            <!-- </div> -->
          </div>
          <!-- Column -->

        </div>
        <!-- Modal Content -->

        <!-- Modal Footer -->
        <div class="flex align-items-center justify-content-between border-top-1 border-300 p-3">
          <div class="w-4">
            <p-button type="button" [label]="'BILL_OWNER_CHANGE.CANCEL' | translate"
              styleClass="p-button-link p-0 text-sm" (click)="closeDialogEvent()">
            </p-button>
          </div>
          <div class="w-8 text-right">
            <p-confirmPopup key="billowner"></p-confirmPopup>
            <button type="button" class="text-sm" [disabled]="!updateBillOwnerForm.valid" pButton pRipple
              [label]="'BILL_OWNER_CHANGE.UPDATE_BILL_OWNER' | translate" (click)="confirm($event)">
            </button>
          </div>
        </div>
        <!--Modal Footer -->

      </form>
    </ng-container>

  </ng-template>

</p-dialog>


<!-- Change Bill Owner Modal  -->
